import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import UsersService from "../Services/UsersService/UsersService";

export const get = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  UsersService.getData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const lastPage = false;
      const status = data.message;
      store.setState({
        isLoading,
        data,
        header: response.headers,
        lastPage,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getModulelist = (store) => {
  UsersService.getModule()
    .then((response) => {
      let data = response.data;
      store.setState({
        module: data,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getList = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  console.log(value);
  UsersService.getData(value)
    .then((response) => {
      let data = response.data;

      const idsSatu = store.state.data.map((item) => item.id);
      const gabung = store.state.data.concat(
        data.filter((item) => !idsSatu.includes(item.id))
      );

      console.log(gabung);
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = refresh ? data : gabung;
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const store = async (store, value, objectUser) => {
  try {
    const response = await UsersService.storeData(value, objectUser);
    const data = response.data;
    notifUtils("Successfully Created User", "success");
    return data;
  } catch (error) {
    const response = error.response;
    if (response.status === 409) {
      notifUtils("Failed Created User: Email is unavailable", "error");
    } else {
      handleError(error);
    }
    return error;
  }
};
export const put = async (store, value, index, objectUser) => {
  try {
    const response = await UsersService.putData(value, objectUser);
    const data = response.data;
    notifUtils("Successfully Updated User", "success");
    return data;
  } catch (error) {
    const response = error.response;
    if (response.status === 409) {
      notifUtils("Failed Created User: Email is unavailable", "error");
    } else {
      handleError(error);
    }
    return error;
  }
};
export const patch = async (store, id, params, notif) => {
  try {
    const response = await UsersService.patch(id, params);
    const data = response.data;
    notifUtils(notif, "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};
export const deleted = async (store, query) => {
  try {
    const response = await UsersService.deleteData(query);
    const data = response.data;
    notifUtils("Successfully Deleted User", "success");
    return data;
  } catch (error) {
    handleError(error);
    return false;
  }
};
